module.exports = __webpack_public_path__ + "img/num4.d46d1f4d.png";